import React, { useState, useEffect } from "react";
import api from "../utils/api";
import { toast, ToastContainer } from "react-toastify";
import { FiUser, FiLock, FiCamera, FiCheck, FiEdit2, FiSave, FiKey } from 'react-icons/fi';

const Profile = () => {
  const [profilePic, setProfilePic] = useState(null);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editedUsername, setEditedUsername] = useState("");

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  useEffect(() => {
    fetchUser();
  }, []);

  async function fetchUser() {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const role = localStorage.getItem("role");
      const token = localStorage.getItem("authToken");
      const programType = "getLoggedInUserDetails";

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("role", role);
      fd.append("programType", programType);

      const response = await api.post("user/userCurl", fd);

      if (response?.data?.length > 0) {
        const userData = response.data[0];
        setUsername(userData.username);
        setEditedUsername(userData.username);
        setEmail(userData.email || "user@example.com");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  const handleProfilePicChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfilePic(reader.result);
        toast.success("Profile picture updated!");
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUsernameUpdate = async () => {
    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "updateUsername";

      const fd = new FormData();
      fd.append("username", editedUsername);
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);

      const response = await api.post("user/userCurl", fd);

      if (response.data.type === "success") {
        setUsername(editedUsername);
        setIsEditing(false);
        toast.success("Username updated successfully!");
      } else {
        toast.error(response.data.data);
      }
    } catch (error) {
      console.error("Error updating username:", error);
      toast.error("Failed to update username");
    }
  };

  async function handleSubmit(e) {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("New passwords don't match!");
      return;
    }

    try {
      const loggedInUser = localStorage.getItem("loggedInUser");
      const token = localStorage.getItem("authToken");
      const programType = "changePassword";

      const fd = new FormData();
      fd.append("oldPassword", currentPassword);
      fd.append("newPassword", newPassword);
      fd.append("confirmPassword", confirmPassword);
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);

      const response = await api.post("user/userCurl", fd);

      if (response.data.type === "success") {
        toast.success("Password updated successfully!");
        setConfirmPassword("");
        setCurrentPassword("");
        setNewPassword("");
      } else {
        toast.error(response.data.data);
      }
    } catch (error) {
      console.error("Error updating password:", error);
      toast.error("Failed to update password");
    }
  }

  return (
    <div className="profile-container">
      <ToastContainer 
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

     

      {/* Main Content Grid */}
      <div className="profile-content-grid">
        {/* Left Column - Profile Info */}
        <div className="profile-left-column">
          {/* Profile Card */}
          <div className="profile-card">
            <div className="card-header">
              <h2><FiUser size={18} /> Personal Information</h2>
            </div>
            
            <div className="profile-pic-section">
              <div className="profile-pic-wrapper">
                <img
                  src={
                    profilePic ||
                    "https://media.istockphoto.com/id/1337144146/vector/default-avatar-profile-icon-vector.jpg?s=612x612&w=0&k=20&c=BIbFwuv7FxTWvh5S3vB6bkT0Qv8Vn8N5Ffseq84ClGI="
                  }
                  alt="Profile"
                  className="profile-pic"
                />
                <label htmlFor="profilePicInput" className="profile-pic-upload-btn">
                  <FiCamera size={16} />
                </label>
                <input
                  type="file"
                  id="profilePicInput"
                  className="d-none"
                  accept="image/*"
                  onChange={handleProfilePicChange}
                />
              </div>
            </div>

            <div className="profile-info-section">
              <div className="info-group">
                <label className="info-label">Full Name</label>
                <div className="input-group">
                  {isEditing ? (
                    <input
                      type="text"
                      className="info-input"
                      value={editedUsername}
                      onChange={(e) => setEditedUsername(e.target.value)}
                    />
                  ) : (
                    <div className="info-value">{username}</div>
                  )}
                 
                </div>
              </div>

             
             
            </div>
          </div>

         
        </div>

        {/* Right Column - Password Update */}
        <div className="profile-right-column">
          <div className="password-card">
            <div className="card-header">
              <h2><FiLock size={18} /> Change Password</h2>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">
                  <FiKey size={14} /> Current Password
                </label>
                <input
                  type="password"
                  className="form-input"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  placeholder="Enter current password"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">
                  <FiKey size={14} /> New Password
                </label>
                <input
                  type="password"
                  className="form-input"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  placeholder="Enter new password"
                  required
                />
                <div className="password-hint">
                  Must be at least 8 characters with letters and numbers
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">
                  <FiKey size={14} /> Confirm New Password
                </label>
                <input
                  type="password"
                  className="form-input"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Confirm new password"
                  required
                />
              </div>

              <div className="form-actions">
                <button type="submit" className="btn-primary">
                  <FiSave size={16} /> Update Password
                </button>
              </div>
            </form>

            <div className="password-tips">
              <h4>Password Tips:</h4>
              <ul>
                <li>Use a combination of uppercase and lowercase letters</li>
                <li>Include numbers and special characters</li>
                <li>Avoid using personal information</li>
                <li>Change your password regularly</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <style>
        {`
          .profile-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
            padding: 1.5rem;
          }

          /* Header */
          .profile-header {
            margin: 0 auto 2rem;
            background: white;
            border-radius: 1rem;
            padding: 1.5rem;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
            border: 1px solid #e2e8f0;
          }

          .header-content h1 {
            font-size: 1.75rem;
            font-weight: 700;
            color: #1f2937;
            margin: 0 0 0.5rem;
            display: flex;
            align-items: center;
            gap: 0.75rem;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }

          .header-content p {
            font-size: 0.875rem;
            color: #6b7280;
            margin: 0;
          }

          /* Content Grid */
          .profile-content-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 1.5rem;
            margin: 0 auto;
          }

          @media (max-width: 1024px) {
            .profile-content-grid {
              grid-template-columns: 1fr;
            }
          }

          /* Cards */
          .profile-card,
          .stats-card,
          .password-card {
            background: white;
            border-radius: 1rem;
            padding: 1.5rem;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
            border: 1px solid #e2e8f0;
            transition: all 0.3s;
          }

          .profile-card:hover,
          .stats-card:hover,
          .password-card:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
          }

          .card-header {
            margin-bottom: 1.5rem;
            padding-bottom: 0.75rem;
            border-bottom: 2px solid #f3f4f6;
          }

          .card-header h2 {
            font-size: 1.125rem;
            font-weight: 600;
            color: #1f2937;
            margin: 0;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          /* Profile Picture */
          .profile-pic-section {
            display: flex;
            justify-content: center;
            margin-bottom: 2rem;
          }

          .profile-pic-wrapper {
            position: relative;
            width: 160px;
            height: 160px;
          }

          .profile-pic {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
            border: 4px solid #e0f2fe;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }

          .profile-pic-upload-btn {
            position: absolute;
            bottom: 10px;
            right: 10px;
            background: #0369a1;
            color: white;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s;
            border: 2px solid white;
          }

          .profile-pic-upload-btn:hover {
            background: #0284c7;
            transform: scale(1.1);
          }

          /* Profile Info */
          .profile-info-section {
            display: flex;
            flex-direction: column;
            gap: 1.5rem;
          }

          .info-group {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
          }

          .info-label {
            font-size: 0.8125rem;
            font-weight: 500;
            color: #6b7280;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }

          .input-group {
            display: flex;
            gap: 0.5rem;
            align-items: center;
          }

          .info-input {
            flex: 1;
            padding: 0.75rem 1rem;
            border: 1px solid #e5e7eb;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            transition: all 0.2s;
          }

          .info-input:focus {
            outline: none;
            border-color: #0369a1;
            box-shadow: 0 0 0 3px rgba(3, 105, 161, 0.1);
          }

          .info-value {
            flex: 1;
            padding: 0.75rem 1rem;
            background: #f9fafb;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            color: #1f2937;
            font-weight: 500;
          }

          .edit-btn {
            background: #f3f4f6;
            border: none;
            border-radius: 0.5rem;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            color: #4b5563;
            transition: all 0.2s;
          }

          .edit-btn:hover {
            background: #e5e7eb;
            color: #1f2937;
          }

          .role-badge {
            background: linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%);
            color: #0369a1;
            padding: 0.25rem 0.75rem;
            border-radius: 999px;
            font-size: 0.75rem;
            font-weight: 600;
            display: inline-block;
          }

          /* Security Stats */
          .security-stats {
            display: flex;
            flex-direction: column;
            gap: 1rem;
          }

          .security-item {
            display: flex;
            align-items: center;
            gap: 1rem;
            padding: 1rem;
            background: #f9fafb;
            border-radius: 0.75rem;
          }

          .security-icon {
            width: 40px;
            height: 40px;
            background: #dcfce7;
            color: #16a34a;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .security-info {
            flex: 1;
          }

          .security-title {
            font-size: 0.8125rem;
            color: #6b7280;
            margin-bottom: 0.25rem;
          }

          .security-status {
            font-size: 0.875rem;
            font-weight: 600;
            color: #16a34a;
          }

          /* Password Form */
          .form-group {
            margin-bottom: 1.5rem;
          }

          .form-label {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-size: 0.875rem;
            font-weight: 500;
            color: #374151;
            margin-bottom: 0.5rem;
          }

          .form-input {
            width: 100%;
            padding: 0.875rem 1rem;
            border: 1px solid #e5e7eb;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            transition: all 0.2s;
          }

          .form-input:focus {
            outline: none;
            border-color: #0369a1;
            box-shadow: 0 0 0 3px rgba(3, 105, 161, 0.1);
          }

          .password-hint {
            font-size: 0.75rem;
            color: #9ca3af;
            margin-top: 0.25rem;
          }

          .form-actions {
            margin-top: 2rem;
          }

          .btn-primary {
            background: linear-gradient(135deg, #0369a1 0%, #0284c7 100%);
            color: white;
            border: none;
            border-radius: 0.5rem;
            padding: 0.875rem 1.5rem;
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
            width: 100%;
            transition: all 0.2s;
          }

          .btn-primary:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(3, 105, 161, 0.3);
          }

          /* Password Tips */
          .password-tips {
            margin-top: 2rem;
            padding: 1.5rem;
            background: #f9fafb;
            border-radius: 0.75rem;
          }

          .password-tips h4 {
            font-size: 0.875rem;
            font-weight: 600;
            color: #374151;
            margin-bottom: 1rem;
          }

          .password-tips ul {
            list-style: none;
            padding: 0;
            margin: 0;
          }

          .password-tips li {
            font-size: 0.75rem;
            color: #6b7280;
            margin-bottom: 0.5rem;
            padding-left: 1.5rem;
            position: relative;
          }

          .password-tips li:before {
            content: "•";
            color: #0369a1;
            position: absolute;
            left: 0.5rem;
          }

          /* Toast Styling */
          .Toastify__toast {
            border-radius: 0.75rem !important;
            font-family: inherit !important;
          }

          .Toastify__toast--success {
            background: #dcfce7 !important;
            color: #166534 !important;
            border: 1px solid #bbf7d0 !important;
          }

          .Toastify__toast--error {
            background: #fee2e2 !important;
            color: #991b1b !important;
            border: 1px solid #fecaca !important;
          }

          /* Responsive Design */
          @media (max-width: 768px) {
            .profile-container {
              padding: 1rem;
            }

            .profile-content-grid {
              gap: 1rem;
            }

            .profile-card,
            .stats-card,
            .password-card {
              padding: 1.25rem;
            }

            .profile-pic-wrapper {
              width: 120px;
              height: 120px;
            }
          }

          @media (max-width: 480px) {
            .header-content h1 {
              font-size: 1.5rem;
            }

            .profile-pic-wrapper {
              width: 100px;
              height: 100px;
            }

            .security-item {
              flex-direction: column;
              text-align: center;
              gap: 0.75rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Profile;